type BenefitProps = {
  title: string;
  description: string;
  icon: string;
};

const Benefit = ({ title, description, icon }: BenefitProps) => (
  <div className="benefit" data-testid="benefit">
    <div className="benefit__icon">{icon && <i className={`fal ${icon} fa--benefit-icon`} />}</div>
    <div className="benefit__copy">
      <span className="benefit__title">{title}</span>
      <p>{description}</p>
    </div>
  </div>
);

export default Benefit;
